<template>
   <div
    :class="[
      'sidebar',
      {'sidebar--1': currentLevel==1 || currentLevel==2 },
      {'sidebar--3': currentLevel==3},
      {'sidebar--4': currentLevel==4},
      { 'sidebar--is-collapsed': sidebar.isCollapsed },
      { 'sidebar--position-right': position === 'right' },
      { 'sidebar--position-left': position === 'left' },
      {'sidebar--tutor':roles.includes('tutor')},
      {'sidebar--tutor--toggle': isActive===true && roles.includes('tutor')}
    ]"
  >
    <div class="sidebar-inner">
      <MenuIcon class="ml-1 menu-icon" />
      <Avatar :class="[{'avatar':togleTutor===false}]"/>
      <!--<div v-if="$route.fullPath !== '/' && roles.includes('student')" class="my-3">
        <h1 class="progress-title text-center">{{ $t('courseProgress') }}</h1>
        <div class="progress-indicator">
          <span>{{ gradeProgress }}%</span>
          <div class="progress-percent" :style="'width: ' + gradeProgress + '%'">
            <span>{{ gradeProgress }}%</span>
          </div>
        </div>
      </div>-->
      <div class="sidebar-menu">
        <VerticalNavMenu :nav-menu-items="allowedRoutes" />
      </div>
    </div>
    <div v-if="roles.includes('tutor')" class="toggle">
      <i v-if="isActive" class="fa fa-chevron-left" aria-hidden="true" v-on:click="openTogled()"></i>
      <i v-else class="fa fa-chevron-right" aria-hidden="true" v-on:click="openTogled()"></i>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import VerticalNavMenu from '../vertical-nav-menu/VerticalNavMenu';
import Avatar from './avatar/Index.vue';
import MenuIcon from '@/layouts/components/MenuIcon.vue';

export default {
  name: 'Sidebar',
  components: { VerticalNavMenu, Avatar, MenuIcon },
  props: {
    position: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      level:0,
       isActive: false
    };
  },
  computed: {
    gradeProgress: function () {
      let percent = 0.0;
      let progress = 0.0;

      this.subjects.forEach(subject => {
        percent += (parseFloat(subject.completed_lessons) * parseFloat(100)) / parseFloat(subject.total_lessons);
      });

      progress = percent / parseFloat(this.subjects.length);
      percent = percent / parseFloat(this.subjects.length);

      return Number.isNaN(progress) ? 0.0 : percent.toFixed(2);
    },
    ...mapGetters({
      allowedRoutes: 'permission/allowedRoutes',
      subjects: 'subject/list',
      sidebar: 'app/sidebar',
      roles: 'auth/roles',
      togleTutor:'app/togleTutor',
      currentLevel:'getCurrentLevel',
    }),
  },
  created(){
    console.log('currente=>',this.currentLevel);
  },
  methods: {
    onToggleSidebar() {
      this.toggleSidebar();
    },
    ...mapActions({
      toggleSidebar: 'app/TOGGLE_SIDEBAR',
      setTogleTutor:'app/TOGGLE_TUTOR',
    }),
    openTogled(){
      console.log('open colla');
      this.isActive = !this.isActive;
      this.setTogleTutor();
    }
  },
  watch:{
    $route (to, from){
        this.level= to.params.level;
    }
  } 
};
</script>
<style scoped lang="scss">
$color-text-blue: #3960A5;
.sidebar--tutor{
  width: 100px !important;
  background-color: #3960A5 !important;
  .avatar{
    display: none;
  }
  /*.sidebar-menu{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }*/
}
.sidebar--tutor--toggle{
  width: 250px !important;
   left: 0 !important;
}
.sidebar-inner{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.sidebar {
  width: 250px;
  position: fixed;
  top: 0;
  bottom: 0;
  transition: all 0.2s ease;
  z-index: 999;
  background-color: rgba($color: #f3ad31, $alpha: 1);
  overflow-y: auto;
  &--position-left{
     left: 0;
     display: grid;
     grid-template-columns: 80% 20%;
      @media all and (max-width: 1000px){
         left: -80px;
        }
  }
  &--position-right{
    right: 0;
  }
  &--is-collapsed{
    width: 0;
    opacity: 0;
  }
  .menu-icon{
    top: 0;
    @media (min-width: 992px) {
       display: none !important;
    }
  }
}
.sidebar--1{
  background-color: $color-text-blue;
  overflow: auto;
}
.sidebar--3{
  background-image: url("~@/assets/icons/menu/new_menu_icons/iconosMiddleSchool/MLms-11.svg");
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  overflow: auto;
}
.sidebar--4{
  background-color:#3960a5;
  border-left: 0.7rem solid white;
  overflow: auto;
}
.boton{
  width: 50px;
  background-color: #f3ad31;
}
.toggle{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #FFF;
  font-size: 1.2rem;
  background-color: rgba($color: #FFF, $alpha: .2);
  i{
    cursor: pointer;
  }
}

</style>
